export default __webpack_public_path__ + "static/media/evenShotMascot.9aba6b0f.png";